var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCashIn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.00004 12H2.66671C2.31309 12 1.97395 11.8595 1.7239 11.6095C1.47385 11.3594 1.33337 11.0203 1.33337 10.6667V5.33333C1.33337 4.97971 1.47385 4.64057 1.7239 4.39052C1.97395 4.14048 2.31309 4 2.66671 4H13.3334C13.687 4 14.0261 4.14048 14.2762 4.39052C14.5262 4.64057 14.6667 4.97971 14.6667 5.33333V8.66667",
    stroke: "#F4FDFA",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.6666 12.667L12.6666 14.667L14.6666 12.667",
    stroke: "#F4FDFA",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12 8H12.0067",
    stroke: "#F4FDFA",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M12.6666 10.667V14.667",
    stroke: "#F4FDFA",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M4 8H4.00667",
    stroke: "#F4FDFA",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M7.99996 9.33366C8.73634 9.33366 9.33329 8.73671 9.33329 8.00033C9.33329 7.26395 8.73634 6.66699 7.99996 6.66699C7.26358 6.66699 6.66663 7.26395 6.66663 8.00033C6.66663 8.73671 7.26358 9.33366 7.99996 9.33366Z",
    stroke: "#F4FDFA",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCashIn);
export default __webpack_public_path__ + "static/media/cash-in.6714d6dfc249642c3c308c35b2acce35.svg";
export { ForwardRef as ReactComponent };